import React from 'react';
import axios from 'axios';
import './LinkInBio.css';
import CookieConsent from './CookieConsent';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const IMAGES = {
  me: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/2t98fqnu_untitled-0235.webp',
  team: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/afx23ryc_untitled-0368.webp',
  hairBA: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/a0a642d5a91c79d4_hair-quiz-card-before-after.jpg',
};

const fireEvent = (name) => {
  axios
    .post(`${API}/track-click`, {
      link_id: name,
      timestamp: new Date().toISOString(),
    })
    .catch((err) => console.error('track-click error:', err));
  if (typeof window !== 'undefined') {
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', name); } catch (e) {}
    }
    if (window.posthog && typeof window.posthog.capture === 'function') {
      try { window.posthog.capture(name); } catch (e) {}
    }
  }
};

const LinkInBio = () => (
  <div className="kh-page">
    <main className="kh-container">
      {/* Hero */}
      <section className="kh-hero" data-testid="hero-section">
        <div className="kh-hero-photo">
          <img src={IMAGES.me} alt="Kristen Hinman" />
        </div>
        <div className="kh-hero-copy">
          <h1 className="kh-h1" data-testid="hero-greeting">hey, you found me</h1>
          <p className="kh-hero-body">
            i&apos;m kristen hinman. mom of 3, business strategist &amp; a woman with a surprising number of opinions about shampoo.
          </p>
          <p className="kh-hero-lead">here are a few ways we can work together.</p>
        </div>
      </section>

      {/* RUN IT */}
      <article className="kh-card kh-card-runit" data-testid="runit-card">
        <div className="kh-runit-image">
          <img src={IMAGES.team} alt="Kristen laughing with women from her team" />
        </div>
        <div className="kh-runit-body">
          <div className="kh-eyebrow kh-eyebrow-lime"><span className="kh-rule" />an 8-question quiz</div>
          <h2 className="kh-headline kh-headline-oat kh-headline-balance" data-testid="quiz-headline">
            could your experience be making you more money?
          </h2>
          <div className="kh-body kh-body-mushroom">
            <p>i work with women who are great at what they do &amp; still only get paid when they show up.</p>
            <p>this quiz is my honest take on whether adding a way to get paid that isn&apos;t tied to your hours makes sense for you. (not everyone should, &amp; i&apos;d rather tell you now.)</p>
          </div>
          <a
            href="https://leveragequiz.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => fireEvent('leverage_quiz')}
            className="kh-btn kh-btn-lime"
            data-testid="take-quiz-button"
          >
            take the quiz →
          </a>
          <a
            href="/run-it"
            onClick={() => fireEvent('runit_video')}
            className="kh-dm-link"
            data-testid="runit-link"
          >
            already know you want in? see how RUN IT works&nbsp;→
          </a>
          <a
            href="https://ig.me/m/iamkristenhinman?ref=w58564447"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => fireEvent('runit_dm')}
            className="kh-dm-link kh-dm-link-tight"
            data-testid="runit-dm-button"
          >
            or DM me directly&nbsp;→
          </a>
        </div>
      </article>

      {/* HAIR */}
      <article className="kh-card kh-card-hair" data-testid="hair-card">
        <div className="kh-hair-image">
          <img
            src={IMAGES.hairBA}
            alt="kristen's hair before and after her monat routine"
          />
        </div>
        <div className="kh-hair-body">
          <div className="kh-eyebrow kh-eyebrow-moss"><span className="kh-rule" />HAIR</div>
          <h2 className="kh-hair-headline">find your hair routine</h2>
          <div className="kh-hair-body-copy">
            <p>thinning, shedding, frizz or just not feeling like your hair used to?</p>
            <p>answer 3 quick questions &amp; i&apos;ll personally build your routine.</p>
          </div>
          <a
            href="https://leveragequiz.com/try-products"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => fireEvent('hair_quiz')}
            className="kh-btn kh-btn-ink kh-btn-hair"
            data-testid="hair-quiz-button"
          >
            build my routine →
          </a>
          <p className="kh-hair-helper">i read every one myself &amp; message you within 24 hours.</p>
          <a
            href="https://monatsocialshop.com/KRISTEN-HINMAN"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => fireEvent('hair_shop')}
            className="kh-hair-shop-row"
            data-testid="hair-shop-link"
          >
            already know what you want? shop the products →
          </a>
          <p className="kh-hair-fine">30-day money-back guarantee &middot; individual results vary.</p>
        </div>
      </article>

      {/* For practitioners & doctors */}
      <article className="kh-card kh-card-ei kh-card-docs" data-testid="practitioners-card">
        <div className="kh-ei-photo">
          <img
            src="https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/cda059b3d25503d5_dr%20michelle%20and%20kristen.webp"
            alt="kristen hinman and dr. michelle mattingly"
          />
        </div>
        <div className="kh-ei-body">
          <div className="kh-eyebrow kh-eyebrow-moss kh-eyebrow-long"><span className="kh-rule" />what if your recommendations kept paying you after the appointment ends?</div>
          <h2 className="kh-headline">for practitioners &amp; doctors</h2>
          <p className="kh-body">
            start with my 8-question quiz. it&apos;s my honest take on whether this makes sense for your practice right now. (not everyone should, &amp; i&apos;d rather tell you now.)
          </p>
          <a
            href="https://leveragequiz.com/practitioners?utm_source=website&utm_content=practitioner_card"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => fireEvent('practitioner_quiz')}
            className="kh-btn kh-btn-ink kh-btn-ei"
            data-testid="practitioner-quiz-button"
          >
            take the practitioner quiz →
          </a>
          <a
            href="https://practice.kristenhinman.com/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => fireEvent('practitioners_briefing')}
            className="kh-docs-link"
            data-testid="practitioners-briefing-link"
          >
            already know you want the details? watch the 12-minute briefing&nbsp;→
          </a>
          <p className="kh-docs-caption" data-testid="practitioners-caption">that&apos;s me with dr. michelle mattingly, ND, LAc, a naturopathic doctor of 20 years on my team.</p>
        </div>
      </article>

      {/* Substack / Energetic Intelligence */}
      <article className="kh-card kh-card-ei" data-testid="substack-card">
        <div className="kh-ei-photo">
          <img
            src="https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/58159994731897ea_logo-substack.png"
            alt="Energetic Intelligence by Kristen Hinman"
          />
        </div>
        <div className="kh-ei-body">
          <div className="kh-eyebrow kh-eyebrow-moss"><span className="kh-rule" />READ MY SUBSTACK</div>
          <h2 className="kh-headline">energetic intelligence</h2>
          <p className="kh-body">
            writing for ambitious moms on intuition, business, money &amp; the body, so you can trust what you know and build a life you actually want.
          </p>
          <a
            href="https://kristenhinman.substack.com/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => fireEvent('substack_subscribe')}
            className="kh-btn kh-btn-ink kh-btn-ei"
            data-testid="substack-subscribe-button"
          >
            subscribe now →
          </a>
        </div>
      </article>

      {/* Follow on Instagram */}
      <article className="kh-card kh-card-ei" data-testid="instagram-card">
        <div className="kh-ei-photo">
          <img
            src="https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/2f258704460221db_instagram%20feed%20iamge.png"
            alt="Kristen Hinman's Instagram grid"
          />
        </div>
        <div className="kh-ei-body">
          <div className="kh-eyebrow kh-eyebrow-moss"><span className="kh-rule" />COME SAY HI ON IG</div>
          <h2 className="kh-headline">@iamkristenhinman</h2>
          <p className="kh-body">
            stories, DMs &amp; the real-time version of everything on this page.
          </p>
          <a
            href="https://www.instagram.com/iamkristenhinman/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => fireEvent('instagram_follow')}
            className="kh-btn kh-btn-ink kh-btn-ei"
            data-testid="instagram-follow-button"
          >
            follow on Instagram →
          </a>
        </div>
      </article>

      {/* Footer */}
      <footer className="kh-footer" data-testid="footer-section" />
    </main>

    <CookieConsent />
  </div>
);

export default LinkInBio;
